module.exports = {
	"name": "angularFileUpload"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/config.json
 ** module id = 1
 ** module chunks = 0
 **/